/* HUMANPEACE® — product card hover (desktop only).
   Crossfades to the product's second image inside the same 4:5 frame.
   The second image is fetched and decoded before the card is marked ready, so hovering
   never shows a blank, white flash or jump. No second image, or a broken one: the card
   keeps its first image and nothing happens on hover. Touch/mobile: does nothing at all
   (no extra downloads). Works for Horizon cards (.card-gallery) and HP cards (.hp-card). */
(() => {
  const desktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const seen = new WeakSet();

  const ready = (img, done) => {
    img.removeAttribute('loading');
    img.decode().then(() => { if (img.naturalWidth > 1) done(); }, () => {});
  };

  const prep = (el) => {
    if (el.classList.contains('card-gallery')) {
      if (el.closest('product-card')?.querySelector('swatches-variant-picker-component')) return;
      const slides = [...el.querySelectorAll('slideshow-slide')].filter((s) => !s.hidden);
      if (slides.length < 2) return;
      const img = slides[1].querySelector('img');
      if (!img || !slides[0].querySelector('img')) return;
      ready(img, () => {
        slides[0].setAttribute('data-hp-main', '');
        slides[1].setAttribute('data-hp-alt', '');
        el.setAttribute('data-hp-hover', '');
      });
    } else {
      const img = el.querySelector('.hp-card__img--alt');
      if (img) ready(img, () => el.setAttribute('data-hp-hover', ''));
    }
  };

  const io = new IntersectionObserver((entries) => {
    for (const e of entries) if (e.isIntersecting) { io.unobserve(e.target); prep(e.target); }
  }, { rootMargin: '600px 0px' });

  const scan = () => {
    if (!desktop.matches) return;
    document.querySelectorAll('.card-gallery, .hp-card').forEach((el) => {
      if (!seen.has(el)) { seen.add(el); io.observe(el); }
    });
  };

  let t;
  const later = () => { clearTimeout(t); t = setTimeout(scan, 150); };
  scan();
  desktop.addEventListener('change', scan);
  new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
})();
